import { Component, OnInit,HostListener, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConnectRestService } from '../services/connect-rest.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppComponent } from '../app.component';
import { AppUtilityService } from '../common/app-utility.service'
import { EnglishTranslation, MalayTranslation } from '../app.constants';
import { DatePipe } from '@angular/common';
import { DataStoreService } from '../data-store.service';
//import { copyFile } from 'fs';

declare var $: any;

@Component({
  selector: 'app-identify-your-company',
  templateUrl: './identify-your-company.component.html',
  styleUrls: ['./identify-your-company.component.scss']
})
export class IdentifyYourCompanyComponent implements OnInit, AfterViewInit {

  ResponseBody: any;
  textContent: any;
  IdentifyYourCompany: FormGroup;
  isEditmode: boolean = false;
  langTranslation: any;
  constructor(
    private connect: ConnectRestService,
    private formBuilder: FormBuilder,
    public router: Router,
    public appComp: AppComponent,
    private AppUtility: AppUtilityService,
    public datePipe: DatePipe,
    private dataStoreService: DataStoreService
  ) {
  }
  @HostListener('document:keypress', ['$event'])
  @HostListener('click', ['$event'])
  // @HostListener('paste', ['$event'])
  @HostListener('copy', ['$event'])
  @HostListener('cut', ['$event'])
  onKeyPress(elemValue) {
    if (elemValue.target.id === "business_registration_no") {
      return this.AppUtility.numericOnlyValidation(elemValue.key);
    }
  }

  ngOnInit() {
    this.langTranslation = sessionStorage.getItem("language");
    this.textContent = this.langTranslation == 'en-us' || this.langTranslation == undefined ? EnglishTranslation.IdentifyYourCompanyScreen : MalayTranslation.IdentifyYourCompanyScreen;

    this.IdentifyYourCompany = this.formBuilder.group({
      businessType: ['', Validators.required],
      // business_name: ['', Validators.required],
      business_registration_no: ['', [Validators.required, Validators.minLength(12)]],
      clauseCheckBox: ['',Validators.required],
      viewLink: ['',Validators.required],
      CheckBox: []
    });
    
  }

  async ngAfterViewInit() {
    if(await this.dataStoreService.getAAStatus()) {
      this.dataStoreService.setAAData('identify-your-company');
    }
  }

  clauseCheckBoxClick(event) {
    var date = this.datePipe.transform(new Date().toUTCString().replace('GMT', ''), 'yyyyMMddTHHmmss') + ".000 GMT";
    if (event.target.checked) {
      this.IdentifyYourCompany.patchValue({ clauseCheckBox: date});
    } else {
      this.IdentifyYourCompany.patchValue({ clauseCheckBox: null});
    }
  }

  clauseLinkClick() {
    this.IdentifyYourCompany.patchValue({ viewLink: true});
    window.open((this.langTranslation === 'ms' ? 'https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/accounts/Customer_Consent_for_Account_Application_BM.pdf' : 'https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/accounts/Customer_Consent_for_Account_Application.pdf'), '_blank');
  }

  showLinkError() {
    return this.IdentifyYourCompany.value.clauseCheckBox && this.IdentifyYourCompany.value.viewLink === '';
  }

  async onSubmit() {   
    var reqID = "R0014"
    var data = {   
      // "BusinessName": "002022847D",
      "BusinessType": this.IdentifyYourCompany.value.businessType,
      "BusinessRegNo": this.IdentifyYourCompany.value.business_registration_no,
      Language: sessionStorage.language
    }
    var requestData = await this.restConnect(data, reqID);

    sessionStorage.setItem("ctos-details", JSON.stringify(requestData));
    sessionStorage.setItem("company-details", JSON.stringify((requestData)));
    sessionStorage.setItem("CTOSConsentDateTime", this.IdentifyYourCompany.value.clauseCheckBox);
    this.ResponseBody = requestData;

    if (requestData.Status == "Success") {   
      if(this.ResponseBody.CompanyList.length > 1) {
        this.router.navigate(['/multiple-company']);
      }else{
        this.router.navigate(['/confirm-your-company']);
      }
    }
    else {
    }   
  }

  async restConnect(data, reqID) {
    this.connect.consoleLog("data value", data)
    var ServResponse = await this.connect.connectRest(data, reqID, '');    
    return ServResponse;
  }

  checkError() {
    return this.IdentifyYourCompany.controls['business_registration_no'].status === "INVALID" && this.IdentifyYourCompany.controls['business_registration_no'].errors.minlength ? true : false;
  }
}

